import type * as Types from 'app/types/graphql';

export type PageEdgeSelectFragment = {
  node?: Types.Maybe<
    Pick<Types.Page, 'baseId' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'>
  >;
};

export type PageSelectFragment = Pick<
  Types.Page,
  'baseId' | 'title' | 'handle' | 'publishedAt' | 'templateSuffix'
>;

export const PageSelectFragmentDoc = `
    fragment PageSelect on Page {
  baseId
  title
  handle
  publishedAt
  templateSuffix
}
    `;
export const PageEdgeSelectFragmentDoc = `
    fragment PageEdgeSelect on PageEdge {
  node {
    ...PageSelect
  }
}
    `;
